import { useFragment, graphql } from 'react-relay';
import { usePeriodGroupValue_itemSearch$key as ItemSearchRef } from './__generated__/usePeriodGroupValue_itemSearch.graphql';

const PERIOD_GROUP_FILTER = 'periodGroup';

export function usePeriodGroupValue({
    itemSearch: itemSearchRef,
}: {
    itemSearch: ItemSearchRef | null;
}): string {
    const itemSearch = useFragment(
        graphql`
            fragment usePeriodGroupValue_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    values {
                        displayName
                    }
                }
            }
        `,
        itemSearchRef
    );
    return (
        itemSearch?.appliedFilters?.find(filter => filter?.name === PERIOD_GROUP_FILTER)
            ?.values?.[0]?.displayName || ''
    );
}
